var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-button-update",on:{"click":_vm.update}},[_vm._v("\n  内容を更新\n")])}
var staticRenderFns = []

export { render, staticRenderFns }